import React from 'react';

const AlumniStats = () => {
  return (
    <div style={{ width: '100%', overflow: 'hidden' }}>
      <iframe 
        src="https://wg.univariety.com/widget/b7a11f2f-7f3e-477b-9dde-6eb269694ceb"
        title="Directory Stats" 
        width="100%" 
        height="600px"
        loading="lazy"
        // React mein 'description' attribute standard nahi hai, 
        // agar error aaye toh ise hata den ya 'aria-label' use karein.
        aria-label="Sanskar School, Jaipur Alumni Statistics"
        style={{ border: 'none', verticalAlign: 'top' }}
      ></iframe>
    </div>
  );
};

export default AlumniStats;